/**
 * DL-01 — a bounded worker pool (parallelism 4, story §B). Items start in
 * order; `shouldStop()` is read before each start, so a stop (disk full, the
 * user's Stop) lets the files in flight finish and starts no new one —
 * nothing is killed mid-write.
 */
export async function runPool<T>(
  items: readonly T[],
  concurrency: number,
  work: (item: T, index: number) => Promise<void>,
  shouldStop: () => boolean = () => false,
): Promise<void> {
  let next = 0;
  const lanes = Math.max(1, Math.min(concurrency, items.length));
  const lane = async (): Promise<void> => {
    while (next < items.length && !shouldStop()) {
      const k = next++;
      const item = items[k];
      if (item === undefined) return;
      await work(item, k);
    }
  };
  await Promise.all(Array.from({ length: lanes }, lane));
}
